import { svgStringToDataUri } from 'app/agriculture/icons/utils/map-icon-utils/svgStringToDataUri';
import { Point } from 'app/agriculture/forms/components/ShapeEditor/icons/Point';
import { SelectedPoint } from 'app/agriculture/forms/components/ShapeEditor/icons/SelectedPoint';
import { HalfHandle } from 'app/agriculture/forms/components/ShapeEditor/icons/HalfHandle';
import { EndPoint } from 'app/agriculture/forms/components/ShapeEditor/icons/EndPoint';
import { NextPoint } from 'app/agriculture/forms/components/ShapeEditor/icons/NextPoint';
import { primaryColourMain } from 'app/agriculture/material';

const BillboardDefaults: Partial<Cesium.Billboard> = {
    show: true,
    scaleByDistance: undefined,
    disableDepthTestDistance: Number.POSITIVE_INFINITY,
    heightReference: 1, // Cesium.HeightReference.CLAMP_TO_GROUND,
    verticalOrigin: 1, // Cesium.VerticalOrigin.BOTTOM
};

export const POINT_ID = 'drawingPoint';
export const HALF_HANDLE_ID = 'drawingHalfHandle';
export const END_POINT_ID = 'drawingEndPoint';
export const LINE_ID = 'drawingLine';
export const FILL_ID = 'drawingFill';

export function createPoint(position: Cesium.Cartesian3, index: number): Partial<Cesium.Billboard> {
    return {
        ...BillboardDefaults,
        width: 16,
        height: 16,
        verticalOrigin: 0,
        id: {
            name: POINT_ID,
            index,
        },
        position,
        image: svgStringToDataUri(Point()),
    };
}

export function createNextPoint(position: Cesium.Cartesian3): Partial<Cesium.Billboard> {
    return {
        ...BillboardDefaults,
        width: 16,
        height: 16,
        verticalOrigin: 0,
        id: {
            name: POINT_ID,
        },
        position,
        image: svgStringToDataUri(NextPoint()),
    };
}

export function createSelectedPoint(
    position: Cesium.Cartesian3,
    index: number,
): Partial<Cesium.Billboard> {
    return {
        ...BillboardDefaults,
        width: 24,
        height: 24,
        verticalOrigin: 0,
        id: {
            name: POINT_ID,
            index,
        },
        position,
        image: svgStringToDataUri(SelectedPoint()),
    };
}

export function createHalfHandle(
    position: Cesium.Cartesian3,
    index: number,
): Partial<Cesium.Billboard> {
    return {
        ...BillboardDefaults,
        width: 10,
        height: 10,
        verticalOrigin: 0,
        id: {
            name: HALF_HANDLE_ID,
            index,
        },
        position,
        image: svgStringToDataUri(HalfHandle()),
    };
}

export function createEndPoint(position: Cesium.Cartesian3): Partial<Cesium.Billboard> {
    return {
        ...BillboardDefaults,
        width: 28,
        height: 28,
        verticalOrigin: 0,
        position,
        id: {
            name: END_POINT_ID,
        },
        image: svgStringToDataUri(EndPoint()),
    };
}

export const lineOptions = {
    color: Cesium.Color.fromCssColorString(primaryColourMain),
    width: 4,
    id: LINE_ID,
    snapping: false,
};

export const polygonOptions = {
    color: Cesium.Color.fromCssColorString(primaryColourMain).withAlpha(0.2),
    id: FILL_ID,
    allowPicking: false,
};
